import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBoardInitLite.query';

export const getCardInit = ({ projectId }: QueryParams) => {
    const querystring = qs.stringify({ projectId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getCardInit${querystring}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
